function getVimeoEmbedHTML(videoSrc: string) {
  return `<iframe src="${videoSrc}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen class="video-player"></iframe>`;
}

function getYoutubeEmbedHTML(videoSrc: string) {
  return `<iframe src="${videoSrc}" style="" class="video-player" title="streaming" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
}

function getSrcTagOfEmbedHTML(iframe: string) {
  const attrs = iframe.split(' ');
  return attrs.find((attr: string) => {
    if (attr.indexOf('src="') > -1) return attr;
    return '';
  });
}

export function getRenderedHTML(type: string, url: string): string {
  if (type.toUpperCase() === 'YOUTUBE') {
    if (url.indexOf('<iframe') > -1) {
      const srcTag = getSrcTagOfEmbedHTML(url);
      return getYoutubeEmbedHTML(srcTag?.substring(5, srcTag.length - 1) as string);
      // eslint-disable-next-line
    } else if (url.indexOf('/embed/') > -1) return getYoutubeEmbedHTML(url);
    else if (url.match(/(.+)(watch\?v=)(.+)/g)) {
      const newUrl = `https://www.youtube.com/embed/${url.substring(url.indexOf('watch?v=') + 8)}`;
      return getYoutubeEmbedHTML(newUrl);
    } else if (url.indexOf('youtu.be/') > -1) {
      const newUrl = `https://www.youtube.com/embed/${url.substring(url.indexOf('youtu.be/') + 9)}`;
      return getYoutubeEmbedHTML(newUrl);
    } else if (url.indexOf('https://') === 0) {
      return getYoutubeEmbedHTML(url);
    }
  } else if (type.toUpperCase() === 'VIMEO') {
    if (url.indexOf('<iframe') > -1) {
      const srcTag = getSrcTagOfEmbedHTML(url);
      return getVimeoEmbedHTML(srcTag?.substring(5, srcTag.length - 1) as string);
      // eslint-disable-next-line
    } else if (url.indexOf('/embed/') > -1) {
      return getVimeoEmbedHTML(url);
    }
    // else if (url.match)
  } else if (type.toUpperCase().indexOf('EMBED') > -1) {
    return url;
  }
  return 'invalid';
}

export default 'use getRenderHTML instead :P';
